/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientTicketLogDto } from '../../models/client-ticket-log-dto';

export interface ClientTicketLogControllerFindAll$Params {
}

export function clientTicketLogControllerFindAll(http: HttpClient, rootUrl: string, params?: ClientTicketLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketLogDto>> {
  const rb = new RequestBuilder(rootUrl, clientTicketLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientTicketLogDto>;
    })
  );
}

clientTicketLogControllerFindAll.PATH = '/api/client-ticket-log';
